import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSidePropsContext } from "next";
import { NextPage } from "next";
import PolicyTemplete from "components/templates/policy";

interface Props {
  isMobile: boolean;
}

const Main: NextPage<Props> = ({ isMobile }) => {
  return isMobile ? (
    <div className="min-w-[360px] max-w-[800px] bg-white w-full">
      <PolicyTemplete />
    </div>
  ) : (
    <div className=" bg-white w-screen max-w-[800px] slim-scroll">
      <PolicyTemplete />
    </div>
  );
};
export default Main;

export async function getServerSideProps({
  locale,
}: GetServerSidePropsContext) {
  return {
    props: {
      ...(await serverSideTranslations(locale as string, ["main"])),
    },
  };
}
